{
  "moreLikely": "Más probable",
  "lessLikely": "Menos probable",
  "yearCompletion": "Probabilidad de alcanzar el objetivo en ",
  "years": " {{years}} años",
  "adjustNote": "Ajuste sus contribuciones iniciales y mensuales a continuación para ver las proyecciones actualizadas",
  "frequency": "Frecuencia"
}
